import { render, staticRenderFns } from "./MyAgent.vue?vue&type=template&id=08c85c1c&scoped=true&"
import script from "./MyAgent.vue?vue&type=script&lang=js&"
export * from "./MyAgent.vue?vue&type=script&lang=js&"
import style0 from "./MyAgent.vue?vue&type=style&index=0&id=08c85c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c85c1c",
  null
  
)

export default component.exports